import { Injectable } from '@angular/core';
import {
  Resolve,
} from '@angular/router';
import { User } from '@app/models/user.model';
import { Store } from '@ngxs/store';
import { EMPTY, map, mergeMap, Observable, of } from 'rxjs';
import { AuthSelectors } from '@app/store/auth/auth.selectors';
import { SetUserList } from '@app/store/data/data.classes';
import { DataSelectors } from '@app/store/data/data.selectors';

@Injectable({
  providedIn: 'root',
})
export class UserListResolverService implements Resolve<User[]> {
  constructor(private store: Store) {}
  resolve(): Observable<User[]> {
    const objectcd = this.store.selectSnapshot(AuthSelectors.objectcd);
    return this.store.dispatch(new SetUserList(objectcd)).pipe(
      map(() => this.store.selectSnapshot(DataSelectors.userList(objectcd))),
      mergeMap((res) => (res ? of(res) : EMPTY))
    );
  }
}
